import { createFileRoute } from "@tanstack/react-router";
import { lazyNamed } from "@/lib/lazy-route";
import { fetchProperties } from "@/lib/portfolio";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";

const LpDesignSolarPage = lazyNamed(
  () => import("@/components/landing/lp-design-solar"),
  "LpDesignSolar",
);

const PATH = "/design-solar";
const TITLE = "Book A Solar Design Call | MCS Certified | CRS Energy";
const DESCRIPTION =
  "Book a free 20 minute Solar Design Call with CRS Energy. MCS certified solar and battery systems designed around your roof across Wales and the South West.";

export const Route = createFileRoute("/design-solar")({
  loader: () => fetchProperties(),
  head: () => ({
    ...pageSeo({ path: PATH, title: TITLE, description: DESCRIPTION }),
    meta: [
      ...pageSeo({ path: PATH, title: TITLE, description: DESCRIPTION }).meta,
      { name: "robots", content: "index, follow" },
    ],
    scripts: [
      serviceJsonLdScript({
        name: "Solar Design Call",
        description: DESCRIPTION,
        serviceType: "Solar PV",
        url: `${SITE.url}${PATH}`,
      }),
    ],
  }),
  component: LpDesignSolarPage,
});
